export default "__VITE_ASSET__50f12111__"